import { Bytes, collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

const COLLECTION = 'userUiPrefs';
const SUBCOLLECTION = 'honeycombSurfaceImages';
export const SHOW_THROUGH_DEFAULT = 0.16;

function asUint8(raw) {
  if (raw instanceof Bytes) return raw.toUint8Array();
  if (raw instanceof Uint8Array) return raw;
  return null;
}

function clampShowThrough(value) {
  if (!Number.isFinite(value)) return SHOW_THROUGH_DEFAULT;
  return Math.min(0.45, Math.max(0.06, Math.round(value * 100) / 100));
}

function parseCloudDoc(appearance, data) {
  const updatedAt =
    typeof data.updatedAt === 'number' && Number.isFinite(data.updatedAt)
      ? Math.round(data.updatedAt)
      : 0;
  if (updatedAt <= 0) return null;
  const deleted = data.deleted === true;
  const jpeg = asUint8(data.jpeg);
  const blob =
    !deleted && jpeg && jpeg.byteLength > 0
      ? new Blob([new Uint8Array(jpeg)], { type: 'image/jpeg' })
      : null;
  return {
    appearance,
    showThrough: clampShowThrough(
      typeof data.showThrough === 'number' ? data.showThrough : SHOW_THROUGH_DEFAULT
    ),
    deleted: deleted || !blob,
    blob,
  };
}

export function subscribeHoneycombSurfaceImages(uid, onDocs) {
  return onSnapshot(
    collection(db, COLLECTION, uid, SUBCOLLECTION),
    (snap) => {
      const docs = [];
      for (const item of snap.docs) {
        if (!item.id.startsWith('nav-honeycomb')) continue;
        const parsed = parseCloudDoc(item.id, item.data());
        if (parsed) docs.push(parsed);
      }
      onDocs(docs);
    },
    () => {
      onDocs([]);
    }
  );
}
